import type { VenueItemDto, VenueListDto } from '~/types/api/venues'
import type { TransferVenue } from './types'
import { parseMoney } from './money'

/** GET /wallet/venues 单行 → 额度转换场馆 */
export function mapVenueItem(dto: VenueItemDto, cat = ''): TransferVenue {
  const known = dto.balance_known !== false
  return {
    k: dto.vendor_code,
    n: dto.display_name,
    cat,
    logo: dto.logo_url || undefined,
    bal: known ? parseMoney(dto.balance_display) : 0,
    balKnown: known,
    mnt: dto.status === 'maintenance',
    pend: !!dto.rescue_pending,
  }
}

export function mapVenueList(
  dto: VenueListDto | undefined,
  resolveCat: string | ((item: VenueItemDto) => string) = '',
): TransferVenue[] {
  return (dto?.venues ?? []).map(item =>
    mapVenueItem(item, typeof resolveCat === 'function' ? resolveCat(item) : resolveCat),
  )
}

/** 按厂商展示名 / vendor_code 匹配场馆（游戏浮层用） */
export function matchVenueByName(venues: TransferVenue[], name: string) {
  const p = name.trim().toLowerCase()
  if (!p) return null
  return (
    venues.find(v => {
      const n = v.n.toLowerCase()
      const k = v.k.toLowerCase()
      return (
        n === p ||
        p === k ||
        n.startsWith(`${k} `) ||
        p.startsWith(`${k} `) ||
        n.includes(p) ||
        p.includes(n)
      )
    }) ?? null
  )
}
